<script lang="ts">
  import type { Snippet } from 'svelte';

  import PageCard from '@/ui/elements/card/PageCard.svelte';

  import LoginCardHeader from './LoginCardHeader.svelte';

  let { children, customerLogo }: { children: Snippet; customerLogo?: string } = $props();
</script>

<PageCard>
  <LoginCardHeader {customerLogo}></LoginCardHeader>
  <div class="flex flex-1 flex-col items-center justify-start gap-8">
    {@render children()}
  </div>
</PageCard>
